import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import moment from 'moment';
import { makeStyles } from '@mui/styles';
import {
	Card, CardActions, CardContent, CardHeader, Grid, Divider,
	colors, List, ListItem, ListItemText, Typography, IconButton,
	Input, Paper, Tooltip, Accordion, AccordionActions, AccordionSummary,
	AccordionDetails, Button, TextField, Stack, AccordionDetail
} from '@mui/material';
import DatePicker from 'components/DatePicker/DatePicker.js';
import DateTimePicker from 'components/DatePicker/DateTimePicker.js';
import { SelectField } from 'components';
import SendIcon from '@mui/icons-material/Send';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
	SetFormState, AddComment, ToggleAttachFileSiteTrackerDialog,
	DownloadAttachments
} from '../../../../../actions/SiteTrackerActions';
import SiteTrackerComments from '../SiteTrackerComments';
import TeamsFilesDatatable from './components/TeamsFilesDatatable';
import './Teams.css';

const useStyles = makeStyles((theme) => ({
	root: {
		marginTop: theme.spacing(1),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
	paper: {
		flexGrow: 1,
		padding: theme.spacing(0.5, 2),
	},
	input: {
		width: '100%',
	},
}));

const TeamTwo = (props) => {
	const { className, tableId, attachments, comments, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const userId = useSelector(state => state.session.user.id);
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.siteTrackerReducer.formState);
	const _hasError = (field) => (!!(formState.touched[field] && formState.errors[field]));
	const dropdowns = useSelector(state => state.siteTrackerReducer.dropdowns);

	// Attachments
	// const [attachmentFiles, setAttachmentFiles] = useState();
	// const [attachmentImage, setAttachmentImage] = useState();

	// useMemo(() => {
	// 	setAttachmentFiles(attachments && attachments.attachmentFiles);
	// 	setAttachmentImage(attachments && attachments.attachmentImage);
	// }, [attachments]);

	const _onAddAttachmentsClick = (title) => {
		dispatch(ToggleAttachFileSiteTrackerDialog(true, tableId, title));
	};

	const _onDownloadAttachmentsClick = (title) => {
		dispatch(DownloadAttachments(userId, tableId, title));
	};

	// const _onRemoveAttachmentsClick = (title) => {
	// 	dispatch(ToggleRemoveFileSiteTrackerDialog(true, tableId, title));
	// };

	const _handleChange = event => {

		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value
			},
			touched: {
				...formState.touched,
				[event.target.name]: true
			}
		});

		rulesManagement(event.target.name, event.target.value);
	};

	const _handleDateChange = (value, name, type = 'date') => {
		let formattedValue = null;

		if (value) {
			if (type === 'date') {
				formattedValue = value.startOf('day').format('YYYY-MM-DD');
			} else {
				formattedValue = value.format('YYYY-MM-DD HH:mm:ss');
			}
		}

		setFormState({
			...formState,
			values: {
				...formState.values,
				[name]: formattedValue
			},
			touched: {
				...formState.touched,
				[name]: true
			}
		});
	};

	const rulesManagement = (fieldName, value) => {
		const datetimeNow = moment().format('YYYY-MM-DD HH:mm:ss');

		if (fieldName === 'monitorPerformance') {
			setFormState({
				...formState,
				values: {
					...formState.values,
					[fieldName]: value,
					'monitorPerformanceDate': moment().format('YYYY-MM-DD HH:mm:ss')
				},
				touched: {
					...formState.touched,
					[fieldName]: true,
				}
			});
			// } else {
			// 	setFormState({
			// 		...formState,
			// 		values: {
			// 			...formState.values,
			// 			[fieldName]: value,
			// 			deliveredDate: null
			// 		},
			// 		touched: {
			// 			...formState.touched,
			// 			[fieldName]: true,
			// 			deliveredDate: true
			// 		}
			// 	});
			// }
		} else if (fieldName === 'kpiClusterPerformanceStatus') {
			setFormState({
				...formState,
				values: {
					...formState.values,
					[fieldName]: value,
					'kpiPerformanceStatusDate': moment().format('YYYY-MM-DD HH:mm:ss')
				},
				touched: {
					...formState.touched,
					[fieldName]: true,
				}
			});
		}
	};

	return (
		<Card {...rest} className={clsx(classes.root, className)}>
			<div>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel1-content"
						id="panel1-header"
						className='highlight'
					>
						<Typography variant="h5" gutterBottom component="div">Monitor Performance</Typography>
					</AccordionSummary>
					<AccordionDetails className="backgroundGrey" style={{ paddingTop: '20px' }}>
						<Grid container spacing={2}>
							<Grid item md={3} xs={3}>
								<SelectField
									id="monitorPerformance"
									name="monitorPerformance"
									hintText="Monitor Performance"
									defaultValue=""
									menuItems={
										(dropdowns && dropdowns.monitorPerformance) || []
									}
									value={formState.values.monitorPerformance}
									onChange={_handleChange}
									error={
										_hasError('monitorPerformance')
											? formState.errors.monitorPerformance[0]
											: null
									}
									style={{ backgroundColor: 'white', border: '1px solid #d5d9e0' }}
								/>
							</Grid>
							<Grid item md={3} xs={3}>
								<DateTimePicker
									id="monitorPerformanceDate"
									name="monitorPerformanceDate"
									label="Monitor Performance Date"
									value={formState.values.monitorPerformanceDate}
									onChange={value => _handleDateChange(value, 'monitorPerformanceDate', 'time')}
									error={
										_hasError('monitorPerformanceDate')
											? formState.errors.monitorPerformanceDate[0]
											: null
									}
									helperText={
										_hasError('monitorPerformanceDate')
											? formState.errors.monitorPerformanceDate[0]
											: null
									}
									minutesStep={1}
									format="DD/MM/YYYY HH:mm"
									disabled
								/>
							</Grid>
						</Grid>
						<br />
						<Grid container spacing={2}>
							<Grid item md={12} xs={12}>
								<SiteTrackerComments title="Monitor Performance Comments" tableId={tableId} comments={comments.monitorPerformance} />
							</Grid>
						</Grid>
						{/* New row */}
						<br />
						<Grid container spacing={2}>
							<Grid item md={12} xs={12}>
								<Divider><Typography variant="h5" gutterBottom component="div">Attachments</Typography></Divider>
							</Grid>
							<Grid item md={10} xs={10}>
								<TeamsFilesDatatable data={(attachments && attachments.monitorPerformance) && attachments.monitorPerformance} tableId={tableId} />
							</Grid>
							<Grid item md={2}>
								<Grid container spacing={2}>
									<Grid item md={12} xs={12}>
										<Button
											className={classes.agreeButton}
											color="primary"
											onClick={() => _onAddAttachmentsClick('monitorPerformance')}
											variant="contained"
											size="small"
											style={{ width: '100%' }}
										>
											Attach Files
										</Button>
									</Grid>
									{/* <Grid item md={12} xs={12} hidden={attachments && attachments.monitorPerformance === null}>
										<Button
											className={classes.agreeButton}
											color="primary"
											onClick={() => _onRemoveAttachmentsClick('monitorPerformance')}
											variant="contained"
											size="small"
											style={{ width: '100%' }}
										>
											Delete All Files
										</Button>
									</Grid> */}
									<Grid item md={12} xs={12}>
										<Button
											className={classes.agreeButton}
											color="primary"
											onClick={() => _onDownloadAttachmentsClick('monitorPerformance')}
											variant="contained"
											size="small"
											style={{ width: '100%' }}
											disabled={(attachments && attachments.monitorPerformance) && attachments.monitorPerformance.length === 0}
										>
											Download All Files
										</Button>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel2-content"
						id="panel2-header"
						className='highlight'
					>
						<Typography variant="h5" gutterBottom component="div">Cluster 95% Date</Typography>
					</AccordionSummary>
					<AccordionDetails className="backgroundGrey" style={{ paddingTop: '20px' }}>
						<Grid container spacing={2}>
							<Grid item md={3} xs={3}>
								<TextField
									id="clusterPercentage"
									name="clusterPercentage"
									label="Cluster (%)"
									variant="outlined"
									error={_hasError('clusterPercentage')}
									fullWidth
									helperText={
										_hasError('clusterPercentage')
											? formState.errors.clusterPercentage[0]
											: null
									}
									value={formState.values.clusterPercentage || ''}
									onChange={_handleChange}
									style={{ backgroundColor: 'white' }}
									disabled
								/>
							</Grid>
							<Grid item md={3} xs={3}>
								<DateTimePicker
									id="cluster95Date"
									name="cluster95Date"
									label="Cluster 95% Date"
									value={formState.values.cluster95Date}
									onChange={value => _handleDateChange(value, 'cluster95Date', 'time')}
									error={
										_hasError('cluster95Date')
											? formState.errors.cluster95Date[0]
											: null
									}
									helperText={
										_hasError('cluster95Date')
											? formState.errors.cluster95Date[0]
											: null
									}
									minutesStep={1}
									format="DD/MM/YYYY HH:mm"
									disabled
								/>
							</Grid>
							<Grid item md={3} xs={3}>
								<SelectField
									id="kpiClusterPerformanceStatus"
									name="kpiClusterPerformanceStatus"
									hintText="KPI Cluster Performance Status"
									defaultValue=""
									menuItems={
										(dropdowns && dropdowns.kpiClusterPerformanceStatus) || []
									}
									value={formState.values.kpiClusterPerformanceStatus}
									onChange={_handleChange}
									error={
										_hasError('kpiClusterPerformanceStatus')
											? formState.errors.kpiClusterPerformanceStatus[0]
											: null
									}
									style={{ backgroundColor: 'white', border: '1px solid #d5d9e0' }}
								/>
							</Grid>
							<Grid item md={3} xs={3}>
								<DateTimePicker
									id="kpiPerformanceStatusDate"
									name="kpiPerformanceStatusDate"
									label="KPI Performance Status Date"
									value={formState.values.kpiPerformanceStatusDate}
									onChange={value => _handleDateChange(value, 'kpiPerformanceStatusDate')}
									error={
										_hasError('kpiPerformanceStatusDate')
											? formState.errors.kpiPerformanceStatusDate[0]
											: null
									}
									helperText={
										_hasError('kpiPerformanceStatusDate')
											? formState.errors.kpiPerformanceStatusDate[0]
											: null
									}
									minutesStep={1}
									format="DD/MM/YYYY HH:mm"
									disabled
								/>
							</Grid>
							<Grid item md={3} xs={3}>
								<SelectField
									id="clusterStatus"
									name="clusterStatus"
									hintText="Cluster Status"
									defaultValue=""
									menuItems={
										(dropdowns && dropdowns.clusterStatus) || []
									}
									value={formState.values.clusterStatus}
									onChange={_handleChange}
									error={
										_hasError('clusterStatus')
											? formState.errors.clusterStatus[0]
											: null
									}
									style={{ backgroundColor: 'white', border: '1px solid #d5d9e0' }}
								/>
							</Grid>
							<Grid item md={3} xs={3}>
								<DatePicker
									id="clusterStatusDate"
									name="clusterStatusDate"
									label="Cluster Status Date"
									value={formState.values.clusterStatusDate}
									onChange={value => _handleDateChange(value, 'clusterStatusDate')}
									error={
										_hasError('clusterStatusDate')
											? formState.errors.clusterStatusDate[0]
											: null
									}
									helperText={
										_hasError('clusterStatusDate')
											? formState.errors.clusterStatusDate[0]
											: null
									}
									format="DD-MM-YYYY"
								/>
							</Grid>
							<Grid item md={3} xs={3}>
								<SelectField
									id="clusterOwner"
									name="clusterOwner"
									hintText="Cluster Owner"
									defaultValue=""
									menuItems={
										(dropdowns && dropdowns.userName) || []
									}
									value={formState.values.clusterOwner}
									onChange={_handleChange}
									error={
										_hasError('clusterOwner')
											? formState.errors.clusterOwner[0]
											: null
									}
									style={{ backgroundColor: 'white', border: '1px solid #d5d9e0' }}
								/>
							</Grid>
						</Grid>
						<br />
						<Grid container spacing={2}>
							<Grid item md={12} xs={12}>
								<SiteTrackerComments title="Cluster 95% Date Comments" tableId={tableId} comments={comments.cluster95Date} />
							</Grid>
						</Grid>
						{/* New row */}
						<br />
						<Grid container spacing={2}>
							<Grid item md={12} xs={12}>
								<Divider><Typography variant="h5" gutterBottom component="div">Attachments</Typography></Divider>
							</Grid>
							<Grid item md={10} xs={10}>
								<TeamsFilesDatatable data={(attachments && attachments.cluster95Date) && attachments.cluster95Date} tableId={tableId} />
							</Grid>
							<Grid item md={2}>
								<Grid container spacing={2}>
									<Grid item md={12} xs={12}>
										<Button
											className={classes.agreeButton}
											color="primary"
											onClick={() => _onAddAttachmentsClick('cluster95Date')}
											variant="contained"
											size="small"
											style={{ width: '100%' }}
										>
											Attach Files
										</Button>
									</Grid>
									{/* <Grid item md={12} xs={12} hidden={attachments && attachments.cluster95Date === null}>
										<Button
											className={classes.agreeButton}
											color="primary"
											onClick={() => _onRemoveAttachmentsClick('cluster95Date')}
											variant="contained"
											size="small"
											style={{ width: '100%' }}
										>
											Delete All Files
										</Button>
									</Grid> */}
									<Grid item md={12} xs={12}>
										<Button
											className={classes.agreeButton}
											color="primary"
											onClick={() => _onDownloadAttachmentsClick('cluster95Date')}
											variant="contained"
											size="small"
											style={{ width: '100%' }}
											disabled={(attachments && attachments.cluster95Date) && attachments.cluster95Date.length === 0}
										>
											Download All Files
										</Button>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel2-content"
						id="panel2-header"
						className='highlight'
					>
						<Typography variant="h5" gutterBottom component="div">Worst Offenders</Typography>
					</AccordionSummary>
					<AccordionDetails className="backgroundGrey" style={{ paddingTop: '20px' }}>
						<Grid container spacing={2}>
							<Grid item md={2} xs={2}>
								<SelectField
									id="worstOffendersStatus"
									name="worstOffendersStatus"
									hintText="Worst Offenders Status"
									defaultValue=""
									menuItems={
										(dropdowns && dropdowns.worstOffendersStatus) || []
									}
									value={formState.values.worstOffendersStatus}
									onChange={_handleChange}
									error={
										_hasError('worstOffendersStatus')
											? formState.errors.worstOffendersStatus[0]
											: null
									}
									style={{ backgroundColor: 'white', border: '1px solid #d5d9e0' }}
									disabled
								/>
							</Grid>
							<Grid item md={3} xs={3}>
								<DatePicker
									id="worstOffendersDate"
									name="worstOffendersDate"
									label="Worst Offenders Date"
									value={formState.values.worstOffendersDate}
									onChange={value => _handleDateChange(value, 'worstOffendersDate')}
									error={
										_hasError('worstOffendersDate')
											? formState.errors.worstOffendersDate[0]
											: null
									}
									helperText={
										_hasError('worstOffendersDate')
											? formState.errors.worstOffendersDate[0]
											: null
									}
									format="DD-MM-YYYY"
								/>
							</Grid>
							<Grid item md={3} xs={3}>
								<SelectField
									id="worstOffentersActualAction"
									name="worstOffentersActualAction"
									hintText="Worst Offenters Actual Action"
									defaultValue=""
									menuItems={
										(dropdowns && dropdowns.worstOffentersActualAction) || []
									}
									value={formState.values.worstOffentersActualAction}
									onChange={_handleChange}
									error={
										_hasError('worstOffentersActualAction')
											? formState.errors.worstOffentersActualAction[0]
											: null
									}
									style={{ backgroundColor: 'white', border: '1px solid #d5d9e0' }}
								/>
							</Grid>
							<Grid item md={2} xs={2}>
								<SelectField
									id="worstOffentersOwner"
									name="worstOffentersOwner"
									hintText="Worst Offenders Owner"
									defaultValue=""
									menuItems={
										(dropdowns && dropdowns.userName) || []
									}
									value={formState.values.userName}
									onChange={_handleChange}
									error={
										_hasError('worstOffentersOwner')
											? formState.errors.worstOffentersOwner[0]
											: null
									}
									style={{ backgroundColor: 'white', border: '1px solid #d5d9e0' }}
								/>
							</Grid>
						</Grid>
						<br />
						<Grid container spacing={2}>
							<Grid item md={12} xs={12}>
								<SiteTrackerComments title="Worst Offenders Comments" tableId={tableId} comments={comments.worstOffenders} />
							</Grid>
						</Grid>
						{/* New row */}
						<br />
						<Grid container spacing={2}>
							<Grid item md={12} xs={12}>
								<Divider><Typography variant="h5" gutterBottom component="div">Attachments</Typography></Divider>
							</Grid>
							<Grid item md={10} xs={10}>
								<TeamsFilesDatatable data={(attachments && attachments.worstOffenders) && attachments.worstOffenders} tableId={tableId} />
							</Grid>
							<Grid item md={2}>
								<Grid container spacing={2}>
									<Grid item md={12} xs={12}>
										<Button
											className={classes.agreeButton}
											color="primary"
											onClick={() => _onAddAttachmentsClick('worstOffenders')}
											variant="contained"
											size="small"
											style={{ width: '100%' }}
										>
											Attach Files
										</Button>
									</Grid>
									{/* <Grid item md={12} xs={12} hidden={attachments && attachments.worstOffenders === null}>
										<Button
											className={classes.agreeButton}
											color="primary"
											onClick={() => _onRemoveAttachmentsClick('worstOffenders')}
											variant="contained"
											size="small"
											style={{ width: '100%' }}
										>
											Delete All Files
										</Button>
									</Grid> */}
									<Grid item md={12} xs={12}>
										<Button
											className={classes.agreeButton}
											color="primary"
											onClick={() => _onDownloadAttachmentsClick('worstOffenders')}
											variant="contained"
											size="small"
											style={{ width: '100%' }}
											disabled={(attachments && attachments.worstOffenders) && attachments.worstOffenders.length === 0}
										>
											Download All Files
										</Button>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</AccordionDetails>
				</Accordion>
				<Accordion>
					<AccordionSummary
						expandIcon={<ExpandMoreIcon />}
						aria-controls="panel2-content"
						id="panel2-header"
						className='highlight'
					>
						<Typography variant="h5" gutterBottom component="div">Report Alert D+7</Typography>
					</AccordionSummary>
					<AccordionDetails className="backgroundGrey" style={{ paddingTop: '20px' }}>
						<Grid container spacing={2}>
							<Grid item md={2} xs={2}>
								<DatePicker
									id="_7DaysAlertDate"
									name="_7DaysAlertDate"
									label="7Days AlertDate"
									value={formState.values._7DaysAlertDate}
									onChange={value => _handleDateChange(value, '_7DaysAlertDate')}
									error={
										_hasError('_7DaysAlertDate')
											? formState.errors._7DaysAlertDate[0]
											: null
									}
									helperText={
										_hasError('_7DaysAlertDate')
											? formState.errors._7DaysAlertDate[0]
											: null
									}
									format="DD-MM-YYYY"
								/>
							</Grid>
							<Grid item md={2} xs={2}>
								<DatePicker
									id="provisionalReportDate"
									name="provisionalReportDate"
									label="Provisional Report Date"
									value={formState.values.provisionalReportDate}
									onChange={value => _handleDateChange(value, 'provisionalReportDate')}
									error={
										_hasError('provisionalReportDate')
											? formState.errors.provisionalReportDate[0]
											: null
									}
									helperText={
										_hasError('provisionalReportDate')
											? formState.errors.provisionalReportDate[0]
											: null
									}
									format="DD-MM-YYYY"
								/>
							</Grid>
							<Grid item md={2} xs={2}>
								<DatePicker
									id="_14DaysReportDate"
									name="_14DaysReportDate"
									label="14Days Report Date"
									value={formState.values._14DaysReportDate}
									onChange={value => _handleDateChange(value, '_14DaysReportDate')}
									error={
										_hasError('_14DaysReportDate')
											? formState.errors._14DaysReportDate[0]
											: null
									}
									helperText={
										_hasError('_14DaysReportDate')
											? formState.errors._14DaysReportDate[0]
											: null
									}
									format="DD-MM-YYYY"
								/>
							</Grid>
						</Grid>
					</AccordionDetails>
				</Accordion>
			</div>
		</Card >
	);
};

TeamTwo.propTypes = {
	className: PropTypes.object,
	tableId: PropTypes.number,
	attachments: PropTypes.object,
	comments: PropTypes.any
};

export default TeamTwo;
